<template src="@/templates/pdfKind.html"></template>

<script>

  // import pdf from '@/assets/pdf/Department_of_Education_Translation_Form_School.pdf';

	export default {
		name: "pdfKind",
    data() {
      return {
        // pdfUrl: pdf
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/pdfKind.vue